import { FAMILY_PORTE } from '@/consts/listFamilies'
import { SENSORY_SHOWER,FIT_SHOWER, TUBO_KNEIP, FEEL_GOOD_SHOWER, BUCKET_SHOWER } from '@/consts/listProducts'
import { AZIENDA, PRIVATO } from '@/consts/listProfileTypes'
import FileController from "@/controllers/FileController"
import { lang } from "@/i18n"
import { de, enGB, es, fr, it } from "date-fns/locale";

export default {
    methods: {
        removeFileAtIndex(index) {
            this.listFileNameUploaded.splice(index, 1);
            this.ticket.uploadTokens.splice(index, 1);

            try {
                this.ticket.uploadTokensV2.splice(index, 1);
            } catch (error) {
                //Fino al passaggio a hubspot il caricamento sarà optional quindi potrebbe non esserci il file
            }
        },
        getProductsForFamily() {
            return this.product_types.filter(p => p.family == this.ticket?.family);
        },
        getProductsInAdditionToDoor() {
            return this.product_types.filter(p => p.family != FAMILY_PORTE);
        },
        getImgProduct() {
            return this.product_types.find(p => p.value == (this.ticket?.family === FAMILY_PORTE ? this.ticket?.product_with_door : this.ticket?.product))?.img || null;
        },
        isProfilePrivato() {
            return this.ticket.customer.profile_type == PRIVATO;
        },
        isProfileAzienda() {
            return this.ticket.customer.profile_type == AZIENDA;
        },
        hasChooseADoor() {
            return this.ticket.family == FAMILY_PORTE;
        },
        async previewFile(event) {
            this.fileUploading = true;

            try {
                const resultV2 = await FileController.uploadFile(event.target.files[0])
                this.ticket.uploadTokensV2.push(resultV2?.data?.data?.fileId);
                this.listFileNameUploaded.push(event.target.files[0]?.name);
                this.fileUploading = false;
                this.onClearError({ key: 'file', value: true })
            } catch (error) {
                console.log(error)
                this.fileUploading = false;
                this.errors.file = true;
            }
        },
        onClearError({ key, value }) {
            if (value) this.errors[key] = false;
            //handling dependent fields
            if (key == 'customer_paese') { this.ticket.customer.province = "" }
            if (key == 'contact_paese') { this.ticket.contact.province = "" }
            if (key == 'family') {
                this.ticket.product = "";
                this.ticket.product_with_door = "";
            }
            if(key == "product"){
                this.errors["file"] = false;
            }
        },
        postMessageIframe() {
            setTimeout(() => {
                window?.parent?.postMessage({
                    height: document?.documentElement?.offsetHeight,
                    step: this.current_step,
                    isConfirmationPage: this.current_step === this.confirmation_step,
                    family: this.ticket?.family || "",
                    product: this.ticket?.family === FAMILY_PORTE
                        ? (this.ticket?.product_with_door || this.ticket?.product || "")
                        : (this.ticket?.product || "")
                }, "*")
            }, 200)
        },
        getLocale() {
            switch (lang) {
                case "it":
                    return "it-IT"
                case "es":
                    return "es-ES"
                case "fr":
                    return "fr-FR"
                case "de":
                    return "de"
                case "en":
                default:
                    return "en-GB"
            }
        },
        getLocaleFns() {
            switch (lang) {
                case "it":
                    return it
                case "es":
                    return es
                case "fr":
                    return fr
                case "de":
                    return de
                case "en":
                default:
                    return enGB
            }
        },
        requiresInvoice() {
            return [SENSORY_SHOWER,FIT_SHOWER, TUBO_KNEIP, FEEL_GOOD_SHOWER, BUCKET_SHOWER].includes(this.ticket?.product)
        }
    }
};
